import axios from 'axios'

export const state = { locale: 'AU' }

export const getters = {}

export const mutations = {}

export const actions = {
  getBusiness({ commit }, id) {
    return axios.get(`/businesses/${id}`)
  },
  updateBusiness({ commit }, business) {
    const data = {
      name: business.name,
      abn: business.abn,
      acn: business.acn,
      logo: business.logo,
      brand_logo: business.brand_logo,
      qr_code: business.qr_code,
      address: {
        line_1: business.address.line_1,
        suburb: business.address.suburb,
        city: business.address.city,
        state: business.address.state,
        postcode: business.address.postcode,
        country_id: business.address.country_id,
        types: business.address.types ? business.address.types.map(type => type.name) : [],
      }
    }
    return axios.put(`/businesses/${business.id}`, data)
  },
}
 